class AddAttendanceService {
    static pageLoader(params: any) {
        const { pageName } = params;
        return Promise.resolve({
            routeInfo: { pageName },
            formConfig: {},
            data: {},
        });
    }
}

export default AddAttendanceService;
